(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.SCPPurchaseContract = api;
})(typeof globalThis === 'object' ? globalThis : window, function () {
  'use strict';
  const id = value => String(value ?? '').split('/').pop();
  const checked = value => value === true || value === 'true' || value === 'on' || value === '1';
  function validate(contract, line, state = {}) {
    const errors = [];
    const fields = contract?.fields;
    if (!contract || contract.version !== 1 || fields?.configurationKnown !== true || !Array.isArray(fields.requiredFields) || !id(contract.productId) || id(contract.productId) !== id(fields.productId)) errors.push('unknown_contract');
    const variant = id(line?.id);
    if (!variant || !Array.isArray(contract?.variantIds) || !contract.variantIds.map(id).includes(variant)) errors.push('invalid_variant');
    if (!Array.isArray(contract?.availableVariantIds) || !contract.availableVariantIds.map(id).includes(variant)) errors.push('unavailable_variant');
    const quantity = String(line?.quantity ?? '1');
    if (!/^[1-9]\d*$/.test(quantity) || !Number.isSafeInteger(Number(quantity))) errors.push('invalid_quantity');
    if (state.fieldGateBlocked || (fields?.requiredFields?.length && state.fieldsReady !== true)) errors.push('fields_not_ready');
    for (const field of Array.isArray(fields?.requiredFields) ? fields.requiredFields : []) {
      if (!field || typeof field.propertyName !== 'string' || !field.propertyName) { errors.push('unknown_contract'); continue; }
      const value = String(line?.properties?.[field.propertyName] ?? '').trim();
      if (!value) errors.push('required_' + field.id);
      if (field.isVin && !/^[A-HJ-NPR-Z0-9]{17}$/.test(value)) errors.push('invalid_vin');
      if (Number(field.limit) > 0 && value.length > Number(field.limit)) errors.push('field_limit_' + field.id);
    }
    const plan = id(line?.selling_plan);
    if (contract?.requiresSellingPlan && !plan) errors.push('selling_plan_required');
    const allocatedPlans = contract?.sellingPlansByVariant?.[variant];
    if (plan && (!Array.isArray(allocatedPlans) || !allocatedPlans.map(id).includes(plan))) errors.push('invalid_selling_plan');
    if (checked(line?.properties?.__shopify_send_gift_card_to_recipient)) {
      if (!contract?.giftCard) errors.push('recipient_not_supported');
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(line.properties['Recipient email'] || '').trim())) errors.push('recipient_email_required');
    }
    if (state.serviceSelected && state.serviceRelationshipQualified !== true) errors.push('service_not_qualified');
    if (state.appBlocked || state.stockBlocked) errors.push('purchase_restricted');
    return { ok: errors.length === 0, errors };
  }
  function readForm(form) {
    const data = new FormData(form);
    const properties = {};
    for (const [key, value] of data) {
      const match = /^properties\[(.*)\]$/.exec(key);
      if (match) properties[match[1]] = value;
    }
    return { data, line: { id: data.get('id'), quantity: data.has('quantity') ? data.get('quantity') : '1', selling_plan: data.get('selling_plan'), properties } };
  }
  function validateForm(form) {
    const node = form.querySelector('[data-scp-purchase-contract]');
    if (!node) return { ok: false, errors: ['missing_contract'] };
    let contract;
    try { contract = JSON.parse(node.textContent); } catch { return { ok: false, errors: ['invalid_contract'] }; }
    const ids = Array.from(form.elements).filter(input => input.name === 'id' && !input.disabled);
    if (ids.length !== 1) return { ok: false, errors: ['ambiguous_variant'] };
    const quantities = Array.from(form.elements).filter(input => input.name === 'quantity' && !input.disabled);
    if (quantities.length > 1) return { ok: false, errors: ['ambiguous_quantity'] };
    const properties = Array.from(form.elements).filter(input => /^properties\[/.test(input.name || '') && !input.disabled && !['checkbox', 'radio'].includes(input.type));
    if (new Set(properties.map(input => input.name)).size !== properties.length) return { ok: false, errors: ['ambiguous_properties'] };
    const { line } = readForm(form);
    const serviceSelected = !!form.ownerDocument.querySelector('[data-paint-service-form-id="' + form.id + '"] [data-paint-service-checkbox]:checked') ||
      Array.from(form.elements).some(input => input.name === 'properties[_tbx_addon_type]' && !input.disabled && input.value);
    return validate(contract, line, {
      fieldsReady: form.dataset.scpFieldsBlocked === 'false', fieldGateBlocked: form.dataset.scpFieldsBlocked === 'true',
      serviceSelected, serviceRelationshipQualified: false,
      stockBlocked: Array.from(form.elements).some(input => input.type === 'submit' && input.disabled && !input.hasAttribute('aria-busy'))
    });
  }
  function report(form, result) {
    const status = form.querySelector('[data-scp-contract-error]');
    if (status) { status.hidden = result.ok; status.textContent = result.ok ? '' : status.dataset.message; if (!result.ok) status.focus(); }
    form.dispatchEvent(new CustomEvent('scp:purchase-validation', { bubbles: true, detail: { ok: result.ok, codes: result.errors } }));
  }
  return { validate, validateForm, readForm, report };
});
